import _cloneDeep from 'lodash/cloneDeep';

import {formatDateTimeWithTCharAndTimezoneAbbrToUserTimezoneWithShift} from '../../utils/dateTime';

export const getRelayTableRowData = (relay, networks, dynamicWanLabel) => {
  const network = networks.find((item) => item.id === relay.networkId);
  const cloned = _cloneDeep(relay);
  delete cloned.networkId;
  const relayNetwork = network ? network.name : '—';
  cloned.network = relayNetwork;
  cloned.policyId = relay.dynamicWanPolicyId;
  cloned.policyName = relay.dynamicWanPolicyName;
  cloned.networkOrDynamic = (relay.dynamicWan)
    ? dynamicWanLabel
    : relayNetwork;

  cloned.lastConfigUpdatingAt = cloned.lastConfigUpdatingAt
    ? formatDateTimeWithTCharAndTimezoneAbbrToUserTimezoneWithShift(cloned.lastConfigUpdatingAt)
    : '—';

  return cloned;
};

export const getRelayTableData = (relays, networks, dynamicWanLabel) =>
  relays.map((relay) => getRelayTableRowData(relay, networks, dynamicWanLabel));
